import { useMemo } from 'react';

import { BaseFields, InferFieldsValue } from '../fields/types';
import { BaseValidationError } from '../types';

import { $internals, FormActionsMap, FormDeclaration } from './types';
import { useSubscription } from './useSubscription';

/**
 * Возвращает текуще значение всех полей формы
 * @param form Форма, значение полей которой нужно получить
 * @param id Идентификатор формы
 * @returns Текущее значение всех полей формы
 **/
export function useFormValue<
    FormName extends string,
    FormFields extends BaseFields,
    FormValidationError extends BaseValidationError,
    FormContextInput,
    FormContext,
    FormActions extends FormActionsMap<FormFields, FormValidationError, FormContext>,
    FormSubmitArg,
    FormSubmitReturnValue,
>(
    form: FormDeclaration<
        FormName,
        FormFields,
        FormValidationError,
        FormContextInput,
        FormContext,
        FormActions,
        FormSubmitArg,
        FormSubmitReturnValue
    >,
    id: string
): InferFieldsValue<FormFields> {
    const instance = useMemo(() => form.getInstance(id), [form, id]);
    useSubscription(instance);
    return instance[$internals].useValue();
}
